import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import SettingsPaymentsForm from 'components/hiboutikForms/SettingsPaymentsForm'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class EditPaymentsHiboutikModal extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    auth: PropTypes.object.isRequired,
    refreshPayments: PropTypes.func.isRequired
  }
  state = { okDisabled: true }
  componentDidMount() {}
  handleHiboutikFormClick = () => {
    this.setState({ okDisabled: false })
  }
  render() {
    const { title, auth } = this.props
    return (
      <ModalWrapper
        open
        maxWidth={'xs'}
        onOk={this.props.refreshPayments}
        title={title}
        cancelText="Fermer"
        okText="Mettre à jour"
        showOk
        okDisabled={this.state.okDisabled}>
        <Grid container direction="column" justify="center">
          <Grid item xs={12}>
            <Typography variant="subheading" gutterBottom>
              Vous devez mofifier ce paramètre sur Hiboutik, cliquez sur le
              boutton suivant :
            </Typography>
            <SettingsPaymentsForm
              onClick={this.handleHiboutikFormClick}
              hiboutikAccount={auth.hiboutikAccount}
            />
            <Typography variant="caption" gutterBottom>
              « Une fois les modifications effectuées et enregistrées sur
              Hiboutik, cliquez sur 'METTRE A JOUR' »
            </Typography>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(EditPaymentsHiboutikModal)



// WEBPACK FOOTER //
// ./src/components/modals/admin/EditPaymentsHiboutikModal.js